import { render, staticRenderFns } from "./useristratorsList.vue?vue&type=template&id=ad87af08&"
import script from "./useristratorsList.vue?vue&type=script&lang=js&"
export * from "./useristratorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports